module.exports = __webpack_public_path__ + "media/images/arrow_down-ecbbbf54280424616fd1b6f598a64327.svg";